import PropTypes from 'prop-types';
import { useContext } from 'react';
import { WHY_ADS } from 'src/common/constants/localizations/ads';
import { LocationAndLocalizationContext } from 'src/common/providers/LocationAndLocalizationProvider';
import VideoAdMediaButtons from './controls/VideoAdMediaButtons';
import VideoAdCountdown from './VideoAdCountdown';
import { VideoAdSlot } from './VideoAdSlot';
import css from './videoAd.module.scss';

export default function VideoAdViewContainer() {
  const { getLocalizedText } = useContext(LocationAndLocalizationContext);

  return (
    <>
      <div data-testid="videoAdTopMessageContainer" className={css.videoAdTopMessageContainer}>
        <div className={css.topOfAdMessage}>{getLocalizedText(WHY_ADS)}</div>
      </div>
      <div className={css.videoAdSlotContainer}>
        <VideoAdSlot />
      </div>
      <div data-testid="videoAdMediaButtons" className={css.videoAdMediaButtonsContainer}>
        <VideoAdMediaButtons />
      </div>
      <div data-testid="videoAdCountdown" className={css.videoAdCountdownContainer}>
        <VideoAdCountdown />
      </div>
    </>
  );
}

VideoAdViewContainer.propTypes = {
  height: PropTypes.number.isRequired,
};
